<template>
  <div>
    <video-player
      :src="playbackUrl"
      :options="videoOptions"
      v-if="readyToPlay"
    ></video-player>
  </div>
</template>
<script>
import VideoPlayer from "./VideoPlayer";
export default {
  name: "LiveStreamPlayer",
  props: {
    session: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  components: {
    VideoPlayer
  },
  data: function() {
    return {
      test: "test",
      readyToPlay: false
    };
  },
  mounted() {
    this.readyToPlay = true;
  },
  computed: {
    videoOptions() {
      let src = "";
      if (this.session.watchStatus === "LIVE") {
        src = `https://stream.mux.com/${this.session.playbackId}.m3u8`;
      } else if (this.session.watchStatus === "COMPLETE") {
        src = `https://stream.mux.com/${this.session.replayAssetId}.m3u8`;
      }
      return {
        controls: true,
        fluid: true,
        sources: [src]
      };
    }
  }
};
</script>

<style scoped></style>
